<template>
    <div>
        <div class="card mb-3">
            <div class="card-header">
                <a name="investSummary"></a>
                <i class="fa fa-money fa-lg"></i><span style="margin-top: 7px"> {{ $t('project.investment.form.sommaire.title') }} </span>
            
                <div class="float-right" style="margin: 7px 0px 0px 15px;">
                  <a href="#invest" name="invest" v-on:click="expandOrCollapse">
                      <span class="fa fa-expand fa-lg" v-if="!localVisible" ></span>
                      <span class="fa fa-compress fa-lg" v-if="localVisible"></span>
                  </a>
                </div>
                <div class="float-right">
                    <ul class="nav nav-pills">
                        <li class="nav-item">
                            <a :class="visualization == 1 ? 'nav-link active' : 'nav-link'" href="#visualisation1" name="visualisation1" @click="setVisualisation(1)">Déboursements</a>
                        </li>
                        <li class="nav-item">
                            <a :class="visualization == 2 ? 'nav-link active' : 'nav-link'" href="#visualisation2" name="visualisation2" @click="setVisualisation(2)">Résumé</a>
                        </li>
                        <li class="nav-item">
                            <a :class="visualization == 3 ? 'nav-link active' : 'nav-link'" href="#visualisation3" name="visualisation3" @click="setVisualisation(3)">Ronde</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="card-body summary" v-if="localVisible">
                
                <div v-if="entites != null && entites.length !== 0">
                    <div v-if="visualization == 1" v-for="(entite,index) in entites" v-bind:data-id="entite.id" :key="entite.id" >
                        
                        <div :class="(index % 2 == 0 ? 'odd' : '') + ' row'">
                            
                            <div class="col-md-2">
                                <label for="categoryInput">{{ $t('project.investment.form.company.round') }}:</label>
                                {{ entite.round}}
                            </div>
                            
                            <div class="col-md-3">
                                <label for="categoryInput">{{ $t('project.investment.form.totalQuantityAnges') }}:</label>
                                {{ entite.quantityAngels}}
                            </div>

                            <!--div class="col-md-2">
                                <label for="typeInput">{{ $t('project.investment.form.sommaire.miniType') }}:</label>
                                {{ entite.typeText}}
                            </div-->
                            
                            <div class="col-md-1">
                                <div class="float-right">
                                <span :class="'totalValue totalValue_' + totalDeboursement(entite)"></span>
                                </div>
                            </div>

                            <div class="col-md-3">
                                <label for="totalValueInput">{{ $t('project.investment.form.totalValue') }}:</label>
                                {{ entite.totalValue }}
                            </div>

                            <div class="col-md-2">
                                <label for="dateOfInvestissementInput">{{ $t('project.investment.form.sommaire.miniDate') }}:</label>
                                {{ entite.dateOfInvestissement | formatDate }}
                            </div>

                            <div  class="col-md-1">
                                <div class="float-right">
                                    <a v-if="entite.show == null || !entite.show" href="#investSummary" @click="expand(index)"><span class="fa fa-expand fa-lg" ></span></a>
                                    <a v-if="entite.show != null && entite.show" href="#investSummary" @click="compress(index)"><span class="fa fa-compress fa-lg"></span></a>
                                </div>
                            </div>
                        </div>

                        <div class="valueTab" v-if="entite.show != null && entite.show && entite.investmentValues != null" v-for="(value, index2) in sortValues(entite.investmentValues)" :key="value.id">

                            <div :class="(index2 % 2 != 0 ? 'value_odd' : 'value_even') + ' row'">
                                <div class="col-md-5" v-if="value.member != null">
                                    <label>{{ $t('project.investment.form.history.member') }} {{value.lead ? ' (Lead)' : ''}}:</label>
                                    {{ value.member.name }}
                                </div>
                                <div class="col-md-5" v-if="value.partner != null">
                                    <label>{{ $t('project.investment.form.history.partner') }}:</label>
                                    {{ value.partner.name }}
                                </div>


                                <div  class="col-md-1">
                                    <div class="float-right">
                                    <span :class="'totalValue totalValue_' + totalDeboursementValue(value)"></span>
                                    </div>
                                </div>
                                
                                <div class="col-md-5">
                                    <label >{{ $t('project.investment.form.history.value') }}:</label>
                                    {{value.value}}
                                </div>

                                
                                <div  class="col-md-1">
                                    <div class="float-right">
                                        <a v-if="value.show == null || !value.show" href="#investSummary" @click="expandValue(value)"><span class="fa fa-expand fa-lg" ></span></a>
                                        <a v-if="value.show != null && value.show" href="#investSummary" @click="compressValue(value)"><span class="fa fa-compress fa-lg"></span></a>
                                    </div>
                                </div>

                            </div>

                            <div v-if="value.show != null && value.show && value.disbursements != null" v-for="disborsement in value.disbursements" :key="disborsement.id">

                                <div class=row>

                                    <div class="col-md-6" >
                                        &nbsp;
                                    </div>

                                    <div class="col-md-3">
                                        <label for="categoryInput">{{ $t('project.investment.form.history.value') }}:</label>
                                        {{ disborsement.value }}
                                    </div>

                                    <div class="col-md-3">
                                        <label for="categoryInput">{{ $t('project.investment.form.sommaire.miniDate') }}:</label>
                                        {{ disborsement.date | formatDate }}
                                    </div>
                                    
                                </div>

                            </div>

                        </div>

                    </div>

                <!-- Resume -->
                    <div v-if="visualization == 2"> 
                        <table class="table table-bordered table-striped" width="100%" cellspacing="0">
                            <thead>
                                <tr>
                                    <th>{{ $t('project.investment.form.id') }}</th>
                                    <th>{{ $t('project.investment.form.company.round') }}  </th>
                                    <th>{{ $t('project.investment.form.type') }}</th>
                                    <th>{{ $t('project.investment.form.dateOfInvestissement') }}</th>
                                    <th>{{ $t('project.investment.form.totalQuantityAnges') }}</th>
                                    <th>{{ $t('project.investment.form.totalQuantityAngesJr') }}</th>
                                    <th>{{ $t('project.investment.form.totalQuantityPartenaires') }}</th>
                                    <th>{{ $t('project.investment.form.totalValueAnges') }}</th>
                                    <th>{{ $t('project.investment.form.totalValueAngesJr') }}</th>
                                    <th>{{ $t('project.investment.form.totalValuePartenaires') }}</th>
                                    <th>{{ $t('project.investment.form.totalValue') }}</th>
                                </tr>
                            </thead>
                            <tfoot>
                                <tr>
                                    <th colspan=4>{{ $t('total') }}</th>
                                    
                                    <th>{{ gettotalQuantityAnges() }}</th>
                                    <th>{{ gettotalQuantityAngesJr() }}</th>
                                    <th>{{ gettotalQuantityPartenaires() }}</th>
                                    <th>{{ gettotalValueAnges() }}</th>
                                    <th>{{ gettotalValueAngesJr() }}</th>
                                    <th>{{ gettotalValuePartenaires() }}</th>
                                    <th>{{ gettotalValue() }}</th>
                                </tr>
                            </tfoot>
                            <tbody>
                                <tr v-for="entite in entites" v-bind:data-id="entite.id" :key="entite.id">
                                    <td>{{ entite.id }}</td>
                                    <td>{{ entite.round }}</td>
                                    <td>{{ entite.typeText }}</td>
                                    <td>{{ entite.dateOfInvestissement | formatDate }}</td>
                                    <td>{{ entite.quantityAngels }}</td>
                                    <td>{{ entite.aqjQuantity }}</td>
                                    <td>{{ entite.quantityPartners }}</td>
                                    <td>{{ entite.amountAngels }}</td>
                                    <td>{{ entite.aqjAmount }}</td>
                                    <td>{{ entite.amountPartners }}</td>
                                    <td>{{ entite.totalValue }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- Round -->
                    <div v-if="visualization == 3">
                        <div id="angeInvestment"></div>
                    </div>
                </div>

                <div v-if="entites == null || entites.length === 0">
                    {{ $t('form.aucun_donne') }}
                </div>
            
            </div>
        </div>
    </div>
  
</template>

<script>
import {InvestmentServiceClient} from '../../shared/service-clients/service-clients'
import ServiceFactory from '../../shared/service-clients/serviceClientFactory'
import SearchMixin from '../../shared/Mixin/SearchMixin'
import moment from 'moment'

export default {
  name: 'InvestmentSummary',
  props: {
    entites: Array,
    visible: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      localVisible: this.visible,
      visualization: 1,
      pivotedData: [],
    }
  },
  methods: {
    setVisualisation: function(visualization) {
      this.visualization = visualization

      if (this.visualization == 3) {
        if (this.pivotedData.length == 0) {
          this.pivotedData = _.flatMap(this.entites, flat =>
            _.map(flat.investmentValues, map => ({
              Valeur: map.value,
              Ange:
                map.partner != null ? map.partner.name : map.member != null ? map.member.familyName + ', ' + map.member.name : 'Pas défini',
              Rond: flat.round,
              Type:
                map.member != undefined && map.memberType !== 3 && map.memberStatus
                  ? 'Ange'
                  : map.member != undefined && map.memberType === 3 ? 'Ange Jr' : 'Autres',
            }))
          )
        }

        let self = this

        setTimeout(function() {
          var sum = $.pivotUtilities.aggregatorTemplates.sum
          var numberFormat = $.pivotUtilities.numberFormat
          var dblFormat = numberFormat({digitsAfterDecimal: 2})

          $('#angeInvestment').pivot(self.pivotedData, {
            rows: ['Type', 'Ange'],
            cols: ['Rond'],
            aggregator: sum(dblFormat)(['Valeur']),
          })
          $('.pvtTable').addClass('table table-bordered table-striped dataTable')
        }, 500)
      }
    },
    expandOrCollapse: function() {
      this.localVisible = !this.localVisible
    },
    fetchData: function() {},
    totalDeboursement: function(entite) {
      let totalValue = parseInt(entite.totalValue)
      if (totalValue === 0) return false

      let totalValues = _.sumBy(entite.investmentValues, function(x) {
        return parseInt(x.value)
      })
      return totalValues === totalValue
    },
    totalDeboursementValue: function(entite) {
      let totalValue = parseInt(entite.value)
      if (totalValue === 0) return false

      let totalValues = _.sumBy(entite.disbursements, function(x) {
        return parseInt(x.value)
      })
      return totalValues === totalValue
    },
    expand: function(index) {
      this.$set(this.entites[index], 'show', true)
    },
    compress: function(index) {
      this.$set(this.entites[index], 'show', false)
    },
    sortValues: function(list) {
      return _.sortBy(list, function(x) {
        return [x.partner, x.member, x.partner != null ? x.partner.name : x.member.name]
      })
    },
    expandValue: function(value) {
      this.$set(value, 'show', true)
    },
    compressValue: function(value) {
      this.$set(value, 'show', false)
    },
    gettotalQuantityAnges: function() {
      return _.sumBy(this.entites, x => x.quantityAngels)
    },
    gettotalQuantityAngesJr: function() {
      return _.sumBy(this.entites, x => x.aqjQuantity)
    },
    gettotalQuantityPartenaires: function() {
      return _.sumBy(this.entites, x => x.quantityPartners)
    },
    gettotalValueAnges: function() {
      return _.sumBy(this.entites, x => x.amountAngels)
    },
    gettotalValueAngesJr: function() {
      return _.sumBy(this.entites, x => x.aqjAmount)
    },
    gettotalValuePartenaires: function() {
      return _.sumBy(this.entites, x => x.amountPartners)
    },
    gettotalValue: function() {
      return _.sumBy(this.entites, x => x.totalValue)
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .dataTables_wrapper{
    padding: 0px;
  }

  .summary .row {
    border: 1px solid #e9ecef;
    padding: 15px 0px;
  }
  .summary .row.odd {
    background-color: rgba(0,0,0,.05);
  }

  .summary .row.value_odd {
    background-color: rgba(50,50,50,.3);
  }
  .summary .row.value_even {
    background-color: rgba(50,50,50,.15);
  }

  .summary .row label {
      font-weight: bold;
  }

  .valueTab{
      padding-left: 50px;
  }
  .summary .row label::before {
      content: "| "
  }
</style>




// WEBPACK FOOTER //
// src/components/Investment/InvestmentSummary.vue